const AUTH_TOKEN_STORAGE_KEY = 'dietWeb.accessToken';

export function getAuthTokenStorageKey(): string {
    return AUTH_TOKEN_STORAGE_KEY;
}

export function getPersistedToken(): string | undefined {
    try {
        const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
        return token || undefined;
    } catch (_err) {
        return undefined;
    }
}

export function persistToken(token?: string) {
    try {
        if (token) {
            localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
            return;
        }

        localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    } catch (_err) {}
}

export function clearPersistedToken() {
    persistToken(undefined);
}
